// extracted by mini-css-extract-plugin
module.exports = {"Loader":"KZHnzuYKJuKw05eEKiBoJ","center":"_1KqwJoBCtQc6SI5gtcTs5I"};